import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import { SectionAccordion } from '../SectionAccordion/render';
import { SliderArtists } from '@/components/molecules/SliderArtists/render';
import { CardArtistType } from '@/components/molecules/CardArtist/render';
import { ListArtists } from '@/components/renders';

import block from './block.json';

/**
 * TYPINGS
 */
type SectionArtistsSliderProps = SectionOneColumnProps & {
	artists?: Array<CardArtistType>;
	showBio?: Boolean;
};

/**
 * COMPONENT
 */
export const SectionArtistsSlider: FC<SectionArtistsSliderProps> &
	BlockConfigs = ({ artists, showBio = false, ...props }) => {
	return isEmpty(artists) ? null : (
		<SectionAccordion {...props}>
			{showBio ? (
				<ListArtists artists={artists} showBio={showBio} />
			) : (
				<SliderArtists artists={artists} />
			)}
		</SectionAccordion>
	);
};

SectionArtistsSlider.slug = block.slug;
SectionArtistsSlider.title = block.title;
